import { render, staticRenderFns } from "./VerbalIdentity.vue?vue&type=template&id=d0dff30e"
import script from "./VerbalIdentity.vue?vue&type=script&lang=ts"
export * from "./VerbalIdentity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports